// extracted by mini-css-extract-plugin
export default {"homeNew":"NewMainComponent_homeNew__H7j+R","bgVid":"NewMainComponent_bgVid__vGRmS","videoMain":"NewMainComponent_videoMain__VO69S","mobile":"NewMainComponent_mobile__Xv7I9"};